// extracted by mini-css-extract-plugin
export default {"description":"L-sri","skeleton-progress":"_9KlGC"};